/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: "/",
    name: "Home",
    i18n: "sections.home.title",
    slug: "home",
    icon: "HomeIcon",
  },
  /*{
    url: "/personal-info",
    name: "ข้อมูลรายบุคคล",
    i18n: "sections.personal-info.nav",
    slug: "personal-info",
    icon: "UserIcon",
    submenu: [
      {
        url: '/personal-info/teacher',
        name: "ข้อมูลอาจารย์",
        i18n: "sections.personal-info.teacher-profile.nav",
        slug: "personal-info-teacher",
      },
    ]
  },*/
  /*{
    name: "Advisor Chat",
    i18n: "sections.advisor.nav",
    slug: "advisor",
    icon: "MessageSquareIcon",
    url: '/advisor',
  },
  {
    name: "Live Class",
    i18n: "sections.live-class.nav",
    slug: "live-class",
    icon: "CastIcon",
    url: '/live-class',
  },*/
  {
    name: "จัดการสอน",
    i18n: "sections.courses.nav",
    slug: "courses",
    icon: "BookOpenIcon",
    submenu: [
      {
        url: '/courses/course-outline',
        name: "Course Outline",
        i18n: "sections.courses.course-outline.nav",
        slug: "course-outline",
      },
      /*{
        url: "/courses/vdo-set",
        name: "VDO Set",
        i18n: "sections.courses.vdo-set.nav",
        slug: "vdo-set",
      },
      {
        url: "/courses/vdo-live-set",
        name: "Vdo Live Set",
        i18n: "sections.courses.vdo-live-set.nav",
        slug: "vdo-live-set",
      },*/
    ]
  },
  /*{
    name: "จัดการข้อสอบ",
    i18n: "sections.examination.nav",
    slug: "examination",
    icon: "BookIcon",
    submenu: [
      /!*{
        url: "/examination/exam",
        name: "รายวิชาในคลังข้อสอบ",
        i18n: "sections.examination.exam.nav",
        slug: "examination-list"
      },*!/
      {
        url: "/examination/exam-upload",
        name: "อัพโหลดข้อสอบ",
        i18n: "sections.examination.exam-upload.nav",
        slug: "exam-upload"
      }
    ]
  },*/
]
